import Color from 'color'
import { useClientStore } from '@/stores/client.store'
import { watch } from 'vue'

const generateColorPalette = (baseColor: string) => {
  const color = Color(baseColor)
  return {
    DEFAULT: baseColor,
    50: color.lightness(95.3).saturate(0.1).hex(),
    100: color.lightness(84.9).saturate(0.1).hex(),
    200: color.lightness(77.6).saturate(0.1).hex(),
    300: color.lightness(67.6).hex(),
    400: color.lightness(61.2).hex(),
    500: color.lightness(51.6).hex(),
    600: color.lightness(47.1).hex(),
    700: color.lightness(36.5).saturate(-0.1).hex(),
    800: color.lightness(28.4).saturate(-0.2).hex(),
    900: color.lightness(21.8).saturate(-0.3).hex(),
    950: color.lightness(13.5).saturate(-0.4).hex(),
  }
}

export const useDynamicColors = () => {
  const clientStore = useClientStore()

  const setPrimaryColor = (colorString: string | null) => {
    const defaultColor = '#1770f0'
    const colorToUse = colorString || defaultColor

    if (typeof document === 'undefined')
      return

    const palette = generateColorPalette(colorToUse)
    const root = document.documentElement

    Object.entries(palette).forEach(([shade, colorValue]) => {
      const [r, g, b] = Color(colorValue).rgb().array()
      root.style.setProperty(`--color-primary-${shade}`, `${r} ${g} ${b}`)
    })
  }

  watch(
    () => clientStore.colors.primary,
    (newColor) => {
      setPrimaryColor(newColor)
    },
    { immediate: true },
  )
}
